import { getUserColor } from "@/lib/user-color";

export interface UnmatchedEmailReviewer {
  id: number;
  name: string;
  shortCode?: string | null;
  color?: string | null;
  status: "pending" | "dont_know";
}

interface UnmatchedEmailParticipantChipsProps {
  reviewers?: UnmatchedEmailReviewer[];
  emailId: string;
}

/**
 * The reviewers on a shared-pool row are deliberately rendered from the
 * server-provided identity data.  This keeps a shortcode's colour consistent
 * with the rest of the application and also lets users without a shortcode
 * remain identifiable by name.
 */
export function UnmatchedEmailParticipantChips({
  reviewers = [],
  emailId,
}: UnmatchedEmailParticipantChipsProps) {
  if (reviewers.length === 0) return null;

  return (
    <div
      className="flex flex-wrap items-center gap-1.5"
      data-testid={`unmatched-reviewers-${emailId}`}
      aria-label="Unmatched email reviewers"
    >
      {reviewers.map((reviewer) => {
        const label = reviewer.shortCode || reviewer.name || `User ${reviewer.id}`;
        const isDeclined = reviewer.status === "dont_know";

        return (
          <span
            key={reviewer.id}
            className={isDeclined
              ? "inline-flex items-center gap-1 rounded-full border border-white/20 px-2 py-0.5 text-[11px] text-white opacity-60"
              : "inline-flex items-center gap-1 rounded-full border border-white/20 px-2 py-0.5 text-[11px] text-white"}
            style={{ backgroundColor: getUserColor(reviewer.color) }}
            title={reviewer.name || label}
            data-testid={`unmatched-reviewer-${emailId}-${reviewer.id}`}
          >
            <span>{label}</span>
            {isDeclined && <span>I don't know</span>}
          </span>
        );
      })}
    </div>
  );
}